export default "__VITE_ASSET__Osp_KPwM__"